import { Component, Input } from '@angular/core';
import { IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'app-affichage-warning',
  templateUrl: './affichage-warning.component.html',
  styleUrls: ['./affichage-warning.component.scss'],
  imports: [IonLabel],
  standalone: true,
})
export class AffichageWarningComponent {
  @Input() name: string = '';
  @Input() icon: string = '';
}
